import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISecCargo, SecCargoDto } from '../../shared/interfaces/database/seguridad';
import { AccessRole, LocalService } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class SecCargoService {
  private readonly baseUrl = `${environment.apiUrl}/api/cargo`;
  role= AccessRole;
  
  constructor(private http: HttpClient, public ls: LocalService) { }

  getCargos(): Observable<ISecCargo[]> {
    return this.http.get<ISecCargo[]>(`${this.baseUrl}`);
  }

  createCargo(request: SecCargoDto): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  updateCargo(id:number, request: SecCargoDto): Observable<string> {
    return this.http.put(`${this.baseUrl}/${id}`, request, { responseType: 'text' });
  }

  deleteCargo(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }
}
